import { apiLeaveCodes } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'leave-codes';

const config = [{ actionType: 'getAll', apiPath: apiLeaveCodes, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
